import axios from 'axios';

const SERVER = 'https://rss.anreader.com/v1';

export const echo = `${SERVER}/actions/echo?url=`;

export const actionRecommend = () => 
  axios.get(`${SERVER}/actions/recommend`)

export const actionSearch = q => 
  axios.get(`${SERVER}/actions/search?q=${encodeURIComponent(q)}`)

export const actionFetchArticles = biz => 
  axios.get(`${SERVER}/publishers/${biz}/articles`)

export const actionFetchFeedInfo = biz => 
  axios.get(`${SERVER}/publishers/${biz}`)

export const actionSubscribeEmail = ({email, biz}) => 
  axios.post(`${SERVER}/actions/subscribe`, {
    email, biz,
  })


// WEBPACK FOOTER //
// ./src/utils/service.js